var render = function render(){var _vm=this,_c=_vm._self._c;return _c('basic-master',{ref:"basicMaster",attrs:{"masterName":"水先案内人","insertDataPageName":"addon-port-master-pilot-insert","data":_vm.data,"columns":_vm.columns,"colorOptions":_vm.colorOptions},on:{"callDelete":_vm.callDelete,"callSave":_vm.callSave,"callUpdateOrder":_vm.callUpdateOrder}})
}
var staticRenderFns = []

export { render, staticRenderFns }